import { render, staticRenderFns } from "./SupplierOutstandingTreeMap.vue?vue&type=template&id=36d90834"
import script from "./SupplierOutstandingTreeMap.vue?vue&type=script&lang=ts"
export * from "./SupplierOutstandingTreeMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports